/* eslint-disable @direct-frontend/modules/no-restricted-entity-imports -- обёртка над shared IntegrationMappingEditor */
import { type FC, Suspense } from 'react';
import { IntegrationMappingEditorStub } from '#shared/components/IntegrationMappingEditor';
import {
    IntegrationMappingEditorWithData,
    type IntegrationMappingEditorWithDataProps,
} from './IntegrationMappingEditorWithData';

export const IntegrationMappingEditorSuspense: FC<IntegrationMappingEditorWithDataProps> = (props) => (
    <Suspense fallback={<IntegrationMappingEditorStub />}>
        <IntegrationMappingEditorWithData {...props} />
    </Suspense>
);
